import axios from './axios-auth'

const postConciergeFlight = async (request) => {
  try {

    const resp = await axios({
      url: '/me/concierge/flight',
      data: request,
      method: 'POST'
    })

    return resp
  }
  catch (e) {
    console.error(e)
    return e
  }
}

const postConciergeHotel = async (request) => {
  try {
    const resp = await axios({
      url: '/me/concierge/hotel',
      data: request,
      method: 'POST'
    })

    return resp
  }

  catch (e) {
    console.error(e)
    return e
  }
}


const postConciergeEvent = async (request) => {
  try {
    const resp = await axios({
      url: '/me/concierge/event',
      data: request,
      method: 'POST'
    })

    return resp
  }

  catch (e) {
    console.error(e)
    return e
  }
}
export { postConciergeFlight, postConciergeHotel, postConciergeEvent }
